import { inject, Injectable } from '@angular/core';
import { SavedTreeItem, VariableApi, VariableCreateRequest, VariableType } from '@selfai-platform/pipeline-common';
import { WorkflowVariablesStore } from '../store';
import { generateRequestId } from '../utils';

@Injectable()
export class VariablesClipboardService {
  private readonly store = inject(WorkflowVariablesStore);

  copyPasteVariable(data: SavedTreeItem) {
    const requestId = generateRequestId();
    const variable = data as VariableApi;
    const newKey = this.generateUniqueKey(
      data.key,
      this.store.variablesAndGroups().map((item) => item.key),
    );

    const createRequest: VariableCreateRequest = {
      varType: VariableType.VARIABLE,
      value: {
        key: newKey,
        value: variable.value,
        description: data.description,
        regexRule: variable.regexRule,
      },
      parentId: data.parentGroupId,
    };

    this.store.createVariable({ requestId, request: createRequest, insertAfterId: data.id });
  }

  private generateUniqueKey(originalKey: string, existingKeys: string[]): string {
    let counter = 1;
    let newKey = `${originalKey}_copy`;

    while (existingKeys.includes(newKey)) {
      newKey = `${originalKey}_copy_${counter}`;
      counter++;
    }

    return newKey;
  }
}
